import { render, staticRenderFns } from "./AccountManagement.template.vue?vue&type=template&id=2e9567d0&scoped=true&"
var script = {}
import style0 from "./AccountManagement.template.vue?vue&type=style&index=0&id=2e9567d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9567d0",
  null
  
)

export default component.exports